<template>
    <div class="modal nb-modal-mask" style="display:block" @keyup.esc="closeModal()">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
            <div class="modal-content">
                <div class="modal-header" :style="`background:${params_pdv.colors.bg_top_bottom ? params_pdv.colors.bg_top_bottom : '#174b79'}!important;`">
                    <h4 class="def-title" :style="`color:${params_pdv.colors.fc_top_bottom ? params_pdv.colors.fc_top_bottom : 'white;'}!important`" id="exampleModalLabel">
                        Informar Observação do Pedido
                    </h4>
                    <span class="mr-2 border p-1 ml-3" :style="`color:${params_pdv.colors.fc_top_bottom ? params_pdv.colors.fc_top_bottom : 'white;'}!important`" v-if="pedv">
                        <i class="fa fa-table mr-1"></i>{{pedv.mesa}}
                    </span>
                    <button @click="closeModal()"  :style="`color:${params_pdv.colors.fc_top_bottom ? params_pdv.colors.fc_top_bottom : 'white;'}!important`" class="close" >
                        <span >&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-3 d-flex justify-content-center" style="height: 180px!important ;max-height: 100%; overflow-y: auto">

                    <!-- CLIENTE SELECIONADO - EXIBE INFORMACOES DE CRÉDITO -->
                    <div class="border d-flex justify-content-center align-items-center col-12" style="padding: 10px;">
                        <div class="row col-5">
                            <small class="lbl-edit">Observação</small>
                            <input type="text" v-model="obs" class="form-control" ref="obs" @keydown.enter="changeToNextEl()">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <v-button danger label="Cancelar" @click="closeModal()" />
                    <v-button nbBtdef label="Confirmar" ref="obsConfirmButton" @click="handleConfirmObs()"  />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        params_pdv:{
        type: Object,
        default: []
        },
        pedv:''

    },
    data(){
        return{
            obs: ''
        }
    },
    methods:{
        handleConfirmObs(){
            let obs = this.obs
            let mesa = this.pedv.mesa
            console.log('teste')
            this.$emit('getObs', {obs, mesa})
            this.closeModal();
        },
        changeToNextEl(){
            this.$nextTick(function (){
                this.$refs.obsConfirmButton.focus()
            })
        },
        closeModal(){
            this.$emit('close')

        }
    },
    created(){
        this.$nextTick(function (){
           this.obs = ''
           this.$nextTick(function (){
               this.$refs.obs.focus()
           })
        })


        window.addEventListener('keyup', function (event){
            if (event.keyCode == 27){
                this.closeModal()
            }
        })
    },

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-modal-obs.vue